import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import Cookies from 'js-cookie';
import CopyIcon from '../../theme/svgs/copy-icon';
import CopiedIcon from '../../theme/svgs/copied-icon';
import config from '../../config';
import { getUrlQueryParams } from '../../helpers/UrlParams';
import '../../theme/fontAwesome.scss';
import './InviteAColleagueModal.scss';

/* tslint:disable */
interface InviteAColleagueModalProps {
    isOpen: boolean;
    onClose: () => void;
    isMobile: boolean;
}

const InviteAColleagueModal = ({ isOpen, onClose, isMobile }: InviteAColleagueModalProps) => {
    const [isCopied, setIsCopied] = useState<boolean>(false);
    const INVITE_A_COLLEAGUE_MODAL_TRIGGER_COOKIE = 'em_iac';
    const PROGRAM_TYPE = 'iac';
    const CHANNEL = 'dl';

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';

            // remove the cookie that triggers the modal
            Cookies.remove(INVITE_A_COLLEAGUE_MODAL_TRIGGER_COOKIE, { domain: '.emarketer.com' });
        } else {
            document.body.style.overflow = 'auto';
        }

        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [isOpen]);
    const copyLinkToClipboard = async () => {
        let invitationLink = `${config.publicUrl}register`; // in case of network failure, default to registration page

        try {
            const currentUrl = window.location.href;
            const response = await fetch(`${config.subscriptionsServiceUrl}/referral`, {
                credentials: 'include',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache',
                },
                method: 'POST',
                body: JSON.stringify({
                    programType: PROGRAM_TYPE,
                    fromUrl: currentUrl,
                    channel: CHANNEL,
                }),
            });
            if (response.ok) {
                const data = await response.json();
                invitationLink = data.InvitationLink; // em.com/referral + query params
            }
        } catch (error) {
            // noop proceed to next step, we will copy the default link
        }

        // separate try catch block for clipboard writeText so that exceptions aren't mixed between api call and clipboard write
        try {
            await navigator.clipboard.writeText(invitationLink);
            setIsCopied(true);
            window.emAna('track', 'InviteAColleague-CopyInviteUrl-Clicked', getUrlQueryParams(invitationLink));
        } catch (error) {
            //noop, its a browser error, because of user permission or browser not supporting clipboard api
        }
    };

    const handleClose = () => {
        setIsCopied(false);
        onClose();
    };

    if (!isOpen) {
        return null;
    }

    if (typeof document === 'undefined') {
        return null;
    }

    return createPortal(
        <div className="iac-modal__overlay">
            <div className="iac-modal">
                <div className="iac-modal__top-bar">
                    <button className="iac-modal__top-bar__close-button" aria-label="Close" onClick={handleClose}>
                        <i className="icon-close" aria-hidden="true" />
                    </button>
                </div>
                {isCopied ? (
                    <div className="iac-modal__content-copied">
                        <CopiedIcon className="iac-modal__content-copied__icon" aria-hidden="true" focusable="false" />
                        <p>Copied to clipboard!</p>
                    </div>
                ) : (
                    <div className="iac-modal__content">
                        <div className="iac-modal__content-copy">
                            <h2 className="iac-modal__content-copy__title">Invite a colleague</h2>
                            <p className="iac-modal__content-copy__text">
                                You’re already using EMARKETER to stay ahead—now invite your team to join for <strong>free</strong> so they can access expert
                                analysis, daily insights, and the latest trends that matter.
                            </p>
                            <button className="iac-modal__content-copy__cta" onClick={copyLinkToClipboard}>
                                <CopyIcon />
                                Copy and share the link
                            </button>
                        </div>
                        <img
                            src={`${config.publicUrl}uploads/images/sitebranding/invite_a_colleague_popup_img_2x.png`}
                            srcSet={`${config.publicUrl}uploads/images/sitebranding/invite_a_colleague_popup_img_mobile_2x.png 456w , ${config.publicUrl}uploads/images/sitebranding/invite_a_colleague_popup_img_2x.png 599w`}
                            sizes="(max-width: 768px) 210px, 280px"
                            alt="Invite a colleague image"
                            className="iac-modal__content-image__img"
                            // set the  width & height based on the device & avoid layout shift
                            width={isMobile ? 210 : 280}
                            height={isMobile ? 261 : 349}
                        />
                    </div>
                )}
            </div>
        </div>,
        document.body
    );
};

export default InviteAColleagueModal;
